import { DrawingTool } from "./DrawingTool.js";

export function createDrawingTool(options = {}) {
  return new DrawingTool(options);
}
